import { render, staticRenderFns } from "./NewCustomTab.vue?vue&type=template&id=470fb40e"
import script from "./NewCustomTab.vue?vue&type=script&lang=ts"
export * from "./NewCustomTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('470fb40e')) {
      api.createRecord('470fb40e', component.options)
    } else {
      api.reload('470fb40e', component.options)
    }
    module.hot.accept("./NewCustomTab.vue?vue&type=template&id=470fb40e", function () {
      api.rerender('470fb40e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/NewCustomTab.vue"
export default component.exports